var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParticleMask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "636px",
    height: "833.5px",
    viewBox: "0 0 636 833.5",
    style: {
      enableBackground: "new 0 0 636 833.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M500.77,446.87L623.8,245.73c19.15-31.31,9.29-72.22-22.02-91.37l-14.58-8.92 c-31.31-19.15-72.22-9.29-91.37,22.02L400.83,322.8c-7.24,11.83-19.31,19.9-33.01,22.05l-199.58,19.74 c-13.7,2.15-25.77,10.22-33.01,22.05L12.2,587.77c-19.15,31.31-9.29,72.22,22.02,91.37l14.58,8.92 c31.31,19.15,72.22,9.29,91.37-22.02l95.01-155.33c7.24-11.83,19.31-19.9,33.01-22.05l199.58-19.74 C481.47,466.76,493.54,458.7,500.77,446.87z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParticleMask);
export default __webpack_public_path__ + "static/media/particle-mask.8f37583ab9846f8758861ce481e6461c.svg";
export { ForwardRef as ReactComponent };